import { getReq } from '../service/API'
import useSWR from 'swr'
import { evaluators } from '../service/api-gateway'

export const useEvaluators = () => {
  const endpoint = evaluators()
  const { data, error } = useSWR(endpoint, getReq, { suspense: true })

  return {
    data: !data ? null : data.data,
    isLoading: !error && !data,
    isError: error,
  }
}
